/** Formatação pt-BR. */

const currency = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const brl = (value: number) => currency.format(value)

/** ``12`` → "12%"; ``12.5`` → "12,5%". */
export const pct = (value: number) =>
  `${String(Number.isInteger(value) ? value : value.toFixed(1)).replace('.', ',')}%`

/** Segundos → "mm:ss". */
export const clock = (seconds: number) => {
  const m = Math.floor(seconds / 60)
  const s = Math.floor(seconds % 60)
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

export const initials = (name: string) => {
  const parts = name.split(' ').filter(Boolean)
  if (parts.length === 0) return '—'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

/** Número em texto livre → número. Aceita "25%", "R$ 150", "12,5". */
export const parseNumber = (raw: string): number => {
  const cleaned = raw.replace(/[^0-9.,-]/g, '').replace(',', '.')
  const value = Number.parseFloat(cleaned)
  return Number.isNaN(value) ? 0 : value
}
